export class SubjectPaginateRequest {
  limit:number
  page: number
  orderByProperty: string
  isDesc: boolean
  name:string
}

